<template>
  <b-row class="grab">
    <b-col>
      <b-card class="border-visible">
        <div slot="header">
          <strong>Configuracion para Ordenar la Frase</strong>
        </div>
        <b-row>
          <b-col lg="12">
            <b-form-group>
              <label for="name">Instrucciones de la Actividad</label>
              <b-form-textarea
                v-model="instrucciones"
                placeholder="Ingrese las Instrucciones para Realizar la Actividad"
                rows="2"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col lg="12">
            <b-form-group>
              <label for="name">No. de Frases</label>
              <b-form-select
                :value="defaultSelected"
                id="elementosNumero"
                class="border-visible"
                :options="noFrases"
                @change="onChangeFrases($event)"
                v-b-popover.hover.left="'Establece el Número de Frases que Tendrá'"
                variant="primary"
              >
                <template slot="first">
                  <option :value="null" disabled>Seleccione un Número</option>
                </template>
              </b-form-select>
            </b-form-group>

            <div v-for="(frase, index) in frasesSelected" :key="index">
              <b-form-group>
                <p>
                  <strong>Frase No. {{index + 1}}</strong>
                  <span style="float: right; font-size: 19px;">
                    <i class="icon-close close-style" @click="removeFrase(index)"></i>
                  </span>
                </p>
                <b-form-input
                  type="text"
                  :id="`frase${index}${frase.id}`"
                  placeholder="Ingrese la frase"
                  v-model="frase.frase"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
          <b-col lg="12" style="text-align: right;">
            <button type="button" class="btn btn-primary" @click="newFrase">
              <i class="icon-plus"></i>&nbsp;Nueva Frase
            </button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>
<script>
var arry = new Array(26);
var noFrases = [];
for (let i = 1; i < arry.length; i++) {
  noFrases.push(i);
}
import OptionsElement from "./OptionsElement";

export default {
  name: "OrdenaFrase",
  components: { OptionsElement },
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      noFrases: noFrases,
      frasesSelected: this.frases,
      previewActivitie: false
    };
  },
  props: {
    frases: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    idElement: { type: Number },
    idColumn: { type: Number, default: null },
    desc: { type: String }
  },
  methods: {
    onChangeFrases(number) {
      this.frasesSelected = [];
      var frasesArry = new Array(number);
      for (let i = 0; i < frasesArry.length; i++) {
        let fraseData = {
          id: i + 1,
          frase: ""
        };
        this.frasesSelected.push(fraseData);
      }
    },
    removeFrase(index) {
      this.$swal({
        type: "warning",
        title: "Eliminar una Frase",
        text: `¿Seguro que Deseas Eliminar la Frase No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.frasesSelected.splice(index, 1);
        }
      });
    },
    newFrase() {
      var i = this.frasesSelected.length;
      var fraseData = {
        id: i + 1,
        frase: ""
      };
      this.frasesSelected.push(fraseData);
    }
  },
  watch: {
    frasesSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "frases",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#preview {
  margin-top: 20px;
  text-align: center;
}
.card {
  margin-top: 10px;
}
.close-style {
  color: red;
  text-align: right;
  float: right;
  position: relative;
  margin-top: 0;
  margin-right: 0;
  font-size: 19px;
}
.custom-control-label {
  cursor: pointer !important;
}
.okAcierto {
  color: green;
}
.badAcierto {
  color: red;
}
/**cursor mover elemento **/
.grab {
  margin: 5px;
  border-style: dashed;
  border-width: thin;
  border-color: #d6d6d6;
  border-radius: 0.2rem;
}
</style>